var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.514014 3.00968C3.46316 6.7705 8.90887 13.7404 8.90887 13.7404V22.4527C8.90887 23.2513 9.56586 23.9048 10.3688 23.9048H13.2888C14.0918 23.9048 14.7488 23.2513 14.7488 22.4527V13.7404C14.7488 13.7404 20.1799 6.7705 23.129 3.00968C23.8736 2.05133 23.1874 0.671875 21.9756 0.671875H1.66739C0.455615 0.671875 -0.230573 2.05133 0.514014 3.00968Z",
    fill: "#7163d0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c8ae6319.svg";
export { ForwardRef as ReactComponent };